import React from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import { Row, Col } from 'components/qstrap'
import Typography from 'components/atoms/Typography'

import TestimonyCard from 'components/molecules/TestimonyCard'
import ThumbnailSlider from 'components/molecules/ThumbnailSlider'

import config from 'config'

import testimonyData from './testimoniesData.json'

const { assets_url: assetsUrl } = config

const AptitudeTestimonies = () => {
  const testimonyItems = testimonyData.map((testimony, idx) => (
    <Col className="aptitude-testimonies__col" md="4" key={`apttestimony-card-${idx}`}>
      <TestimonyCard
        direction="row"
        {...testimony}
        img={`${assetsUrl}${testimony.img}`}
      />
    </Col>
  ))

  return (
    <div className="aptitude-testimonies">
      <div className="aptitude-testimonies__gray-accent-bg"/>
      <SectionContainer
        className="aptitude-testimonies__section"
        paddingTop={80}
        backgroundColor="transparent"
      >
        <Container>
          <Typography component="h2" variant="title" className="text-variant-title-sm text-center">
            Apa Kata Mereka?
          </Typography>
          <div className="m-b-md hide-sm">
            <TestimonyCard
              rowContent
              {...testimonyData[0]}
              img={`${assetsUrl}${testimonyData[0].img}`}
            />
          </div>
          <Row className="aptitude-testimonies__row">
            {testimonyItems}
          </Row>
        </Container>
        <div className="aptitude-testimonies__mobile">
          <ThumbnailSlider>
            {testimonyItems}
          </ThumbnailSlider>
        </div>
      </SectionContainer>
      <style jsx global>
        {`
          .aptitude-testimonies {
            position: relative;
            &__gray-accent-bg {
              position: absolute;
              background-color: #f6f7fa;
              height: 50%;
              top: 0;
              right: 0;
              left: 0;
            }
            &__section {
              position: relative;
            }
            .testimony {
              height: 100%;
            }
            &__row {
              display: flex;
              @media screen and (max-width: 767px) {
                display: none !important;
              }
            }
            &__mobile {
              .tmvn-carousel__items {
                box-shadow: 0 4px 16px 0 rgba(107, 143, 188, 0.4);
              }
              @media screen and (min-width: 768px) {
                display: none;
              }
            }
            &__control-button {
              width: 48px;
              height: 48px;
              background: #0fc3c4;
              border-radius: 100%;
              margin: 16px 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              border: none;
              &:focus {
                outline: none;
              }
            }
            &__mobile-buttons {
              display: flex;
              justify-content: center;
            }
            :global(.slick-track) {
              display: flex;
              max-height: none;
            }
            :global(.slick-slide) {
              height: inherit;
            }
            :global(.slick-slide > div) {
              height: 100%;
            }
            &__col {
              @media screen and (max-width: 767px) {
                height: 100%;
              }
            }
            .hide-sm {
              @media screen and (max-width: 767px) {
                display: none;
              }
            }
            @media screen and (min-width: 768px) {
              :global(&__col:nth-child(1)) {
                display: none;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

export default AptitudeTestimonies
